import Axios, { AxiosRequestConfig } from "axios";

export const profileConfig = Axios.create();
export const emobilityConfig = Axios.create();

export const profileInstance = <T>(config: AxiosRequestConfig): Promise<T> => profileConfig({ ...config }).then(
  ({ data }) => data,
);

export const emobilityInstance = <T>(config: AxiosRequestConfig): Promise<T> => emobilityConfig({ ...config }).then(
  ({ data }) => data,
);